<template>
<div class="chapter">
<div class="inner_page">
<div id="Acknowledgements">
<p class="ack-title"><a id="page_4">Acknowledgements</a></p><a id="page_4">
<p class="fig-ack"><img alt="" class="image" src="images/ack-line.jpg"/></p>
<p class="ack-para">Marguerite Patten would like to thank the following people for their helpful information:</p>
<p class="ack-para">The Tea Council Ltd<br/>Dominic Beddard, Wilson Smithett &amp; Co, Tea Brokers<br/>R Twining and Company Ltd<br/>Miss G A Holloway, Chief Home Economist, The Flour Advisory Bureau Ltd<br/>Suranja Cooradia, Novosti Press Agency<br/>The Tea Board of India<br/>D R Collard, The Anglo-Arab Association<br/>Simon Halewood, Promotion and Public Relations Manager, Japan National<br/>Tourist Organization<br/>Chinese Embassy<br/>Moroccan Tourist Office</p>
</a></div><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?6f5780ee